export enum ApplicantTypeEnum {
  Individual = 'Individual',
  Joint = 'Joint',
  Company = 'Company'
}
